var events = {
	selectors: { },

	init: function () {
		var self = this;

        self.closePupupModal();
        self.closeEvent();
        self.confirmCloseEventModal();

        var today = new Date().toISOString().split('T')[0];
        var dateInputs = document.querySelectorAll('input[type="date"]');

        dateInputs.forEach(function(input) {
            input.min = today;
        });

	},

    closePupupModal() {
		let closeModal = document.querySelectorAll( ".js-closePopupModal" );
		for (let i = 0; i < closeModal.length; i++) {
			closeModal[i].addEventListener('click', function(e) {
        		e.preventDefault();
				closeModal[i].closest( ".popup-modal" ).classList.remove( "active" );
			});
		}

    },
    confirmCloseEventModal(){
		let closeModal = document.querySelectorAll( ".js-confirmCloseEventModalOpen" );
		for (let i = 0; i < closeModal.length; i++) {
			closeModal[i].addEventListener('click', function(e) {
        		e.preventDefault();
                //close 
                closeModal[i].closest( ".js-dropdown-modal-parent" ).querySelector('.js-dropdown-modal').classList.remove( "active" );
				closeModal[i].closest( ".js-dropdown-modal-parent" ).querySelector( ".js-confirmCloseEventModal").classList.add( "active" );
			});
		}
    },
    closeEvent: function() {
        let self = this;

        const closeEventButton = document.querySelectorAll('.js-closeEvent');		
        //console.log("1");
        if( !closeEventButton.length ) {  return; }
        //console.log("2");
        closeEventButton.forEach( button  => {
            button.addEventListener('click', (e) => {

                console.log("adsads");
                e.preventDefault();
            
                let formData = new FormData();
                formData.append( 'action', 'close_event' );
                formData.append( 'nonce', sikmoVars.nonce );
                formData.append( 'event_id', button.dataset.event_id ); 

                fetch( sikmoVars.ajax_url, {
                    method: 'POST',
                    credentials: 'same-origin', 
                    body: formData
                })
                .then( response => response.json() )
                .then( data => {
                    console.log(data);

                    button.closest( ".js-dropdown-modal-parent" ).querySelector( ".js-finalCloseEventModal").classList.add( "active" );

                    //Přesměroání? Zavření?
                
                })
                .catch( error => console.error('Error:', error)) ;
            
            });
        });
	},
};

export { events };


